import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api/api-client';
import { Product, Modifier } from '../../types';

export const THUNK_NAMES = {
  GET_PRODUCT_BY_ID: 'getProductById',
  GET_PRICELIST_CATEGORIES: 'getPricelistCategories',
  GET_PRICELIST_MODIFIERS: 'getPricelistModifiers'
};

export const getProductById = createAsyncThunk<Product, string>(
  `singleProduct/${THUNK_NAMES.GET_PRODUCT_BY_ID}`,
  async (id: string) => apiClient.getProductById(id)
);

export const getPricelistCategories = createAsyncThunk<Record<string, string[]>, string>(
  `singleProduct/${THUNK_NAMES.GET_PRICELIST_CATEGORIES}`,
  async (pricelistId: string) => apiClient.getCategoriesForPricelist(pricelistId)
);

export const getPricelistModifiers = createAsyncThunk<Modifier[], string>(
  `singleProduct/${THUNK_NAMES.GET_PRICELIST_MODIFIERS}`,
  async (pricelistId: string) => apiClient.getPricelistModifiers(pricelistId)
);
